export default __webpack_public_path__ + "static/gradient3-f2963c6f876fa66e9124f694222e4b31.webp";